"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactstrap = require("reactstrap");

require("./InputFileUpload.scss");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var InputFileUpload = function InputFileUpload(_ref) {
  var required = _ref.required,
      placeholder = _ref.placeholder,
      onFile = _ref.onFile,
      errorMsgs = _ref.errorMsgs,
      errorFileNull = _ref.errorFileNull,
      mimetypeAcept = _ref.mimetypeAcept,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      _ref$isFileUpload = _ref.isFileUpload,
      isFileUpload = _ref$isFileUpload === void 0 ? false : _ref$isFileUpload;
  var inputRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      file = _useState2[0],
      setFile = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isLoad = _useState6[0],
      setIsLoading = _useState6[1];

  (0, _react.useEffect)(function () {
    if (isFileUpload === -2) {
      setError(errorMsgs[3]);
    }
  }, [isFileUpload]);
  (0, _react.useEffect)(function () {
    setIsLoading(isLoading);
  }, [isLoading]);
  (0, _react.useEffect)(function () {
    errorFileNull && setError(errorMsgs[2]);
  }, [errorFileNull]);

  var onFileUpload = function onFileUpload(e) {
    var filesAdded = e.dataTransfer ? e.dataTransfer.files : e.target.files;

    if (mimetypeAcept.filter(function (i) {
      return i === filesAdded[0].name.split('.').pop();
    }).length === 0) {
      setError(errorMsgs[1]);
      setFile(filesAdded[0]);
      return;
    }

    if (filesAdded[0].size / 1000000 > 40) {
      setError(errorMsgs[0]);
      setFile(filesAdded[0]);
      return;
    } else {
      setError(null);
      onFile(filesAdded[0]);
      setFile(filesAdded[0]);
      setIsLoading(true);
    }
  };

  var onClickAttach = function onClickAttach() {
    if (!isLoad) {
      onFile(null);
      setFile(null);
      inputRef.current.value = '';
      inputRef.current.click();
    }
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-input-file-upload ".concat(file != null ? 'populated' : '', " ").concat(error ? 'error' : '')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "input-file-upload-container",
    onClick: onClickAttach
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-ifu-file-wrapper"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "gcl-ifu-placeholder"
  }, placeholder, required && /*#__PURE__*/_react["default"].createElement("span", {
    className: "required"
  }, "*")), file != null && /*#__PURE__*/_react["default"].createElement("span", {
    className: "gcl-ifu-filename"
  }, file.name)), isLoad ? /*#__PURE__*/_react["default"].createElement(_reactstrap.Spinner, {
    color: "primary",
    className: "spinner"
  }) : /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon upload"
  })), error && /*#__PURE__*/_react["default"].createElement("span", {
    className: "gcl-labelInput-error"
  }, error), /*#__PURE__*/_react["default"].createElement("input", {
    type: "file",
    className: "input",
    disabled: isLoad,
    onChange: onFileUpload,
    ref: inputRef
  }));
};

var _default = InputFileUpload;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/components/Input/InputFileUpload/InputFileUpload.js
// module id = 1905
// module chunks = 0